

<template>
  <div class="public_table" >
<!--  右上角展开小图标，包含可查看列表  -->
    <el-popover class="operation" placement="bottom" trigger="click">
      <div class="AllArrange">
        <el-checkbox-group v-model="AllArrange">
          <el-checkbox v-for="(item,index) in PublicTable.arrange" :key="index" :checked="item.defaultShow" :label="item.arrangeName" @change="handleCheckedArrangeChange(item)">{{item.arrangeName}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="reference">
        <i class="el-icon-s-operation"></i>显示列
      </div>
    </el-popover>


<!--  列表  -->
<!--    <el-button type="primary" style="background: #71bdff;border:none;margin-bottom:10px">导出</el-button> -->
    <el-table :data="PublicTable.rows" style="width: 100%;margin-bottom: 30px" @selection-change="handleSelectionChange">
      <el-table-column v-if="PublicTable.selection" type="selection" width="55"></el-table-column>
      <el-table-column align="center" v-if="PublicTable.showIndex" type="index" width="50"></el-table-column>

      <el-table-column v-for="(item,index) in PublicTable.arrange" :key="index" align="center" :label="item.arrangeName" :prop="item.arrange" v-if="item.defaultShow" :sortable="item.sortable">

      </el-table-column>
      <el-table-column v-if="PublicTable.operate.isshow" :label="PublicTable.operate.operateName" align="center">
        <template v-slot="scope" class="operate">
          <span class="item" v-show="scope.row.add" @click="$emit('AddListClick',scope.row)">{{ scope.row.add }}</span>
          <span class="item" v-show="scope.row.edit" @click="$emit('EditListClick',scope.row)">{{ scope.row.edit}}</span>
          <span class="item" v-show="scope.row.delete" @click="$emit('DeleteListClick',scope.row)">{{ scope.row.delete }}</span>
          <span class="item" v-show="scope.row.other" @click="$emit('otherListClick',scope.row)">{{scope.row.other}}</span>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination :hide-on-single-page="true" @current-change="handleinitialization" :current-page.sync="currentPage" layout="total, prev, pager, next" :page-size="PageSize" :total="PageTotal">
    </el-pagination>

  </div>
</template>
<script>

export default {
  props:{
    PublicTable:{
      type:Object  
    },
    PageSize:{
      type:Number
    },
    PageTotal:{
      type:Number
    },
    PageName:{
      type:String
    },
    currentPage:{
      type:[Number,String]
    }
  },
  model:{
    prop:'PublicTable'
  },
  data() {
    return {
      AllArrange:[],
      AllArrangeShow:false
    }
  },
  watch:{
    PublicTable(newval,oldval){
      if(localStorage.getItem(this.PageName) && localStorage.getItem(this.PageName)!="undefined"){
      let localStoraData=JSON.parse(localStorage.getItem(this.PageName));
        for(let item of localStoraData){
          for(let list of newval.arrange){
            if(list['arrange']==item['arrange']){
              list['defaultShow']=item['defaultShow']
            }
          }
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    handleCheckedArrangeChange(val){
      val.defaultShow=!val.defaultShow;
    },
  //   分页
    handleinitialization(e){
      this.$emit('handleinitialization',e);
    },
  //   全选和反选
    handleSelectionChange(e){
      this.$emit('handleSelectionChange',e);
    }
  },
  beforeDestroy() {
    localStorage.setItem(this.PageName,JSON.stringify(this.PublicTable.arrange));
  }
}
</script>

<style>
.public_table{background: #fff;}
.public_table .operation{float: right;padding-bottom: 10px;position:relative;cursor: pointer;}
.public_table .operation i{padding-right: 5px;}
.public_table .el-pagination .btn-next,.public_table .el-pagination .btn-prev,.public_table .el-pagination button:disabled,.public_table .el-pager li{background:none;}
.item{padding: 0 5px;}
.public_table  .el-table td,.public_table .el-table th{padding:8px 0;}
//.public_table thead th{background:#71bdff !important;}
.AllArrange label{display: block}
.cell .item{cursor: pointer;}
</style>